import { defineSlotRecipe } from '@chakra-ui/react';

import { summaryHeaderContentSlots } from '../slots';

export default defineSlotRecipe({
  slots: summaryHeaderContentSlots,
});
